import React from "react"
import { GoogleMap, LoadScript } from "@react-google-maps/api"
import mapStyles from "./googleMapStyles"

const options = {
  disableDefaultUI: true,
  styles: mapStyles,
}

const MapContainer = ({ children, isMobile, mapCenter, tenantId }) => {
  const containerStyle = {
    width: "100%",
    height: isMobile ? "40vh" : "100vh",
  }
  return (
    <LoadScript
      googleMapsApiKey="AIzaSyDqN6PT6GIrQzGyqD6PVFI6F5R7aIlsH6M"
      channel={tenantId}
    >
      <GoogleMap
        center={mapCenter}
        mapContainerStyle={containerStyle}
        options={options}
        zoom={10}
      >
        {children}
      </GoogleMap>
    </LoadScript>
  )
}

export default MapContainer
